<template>
  <div>
    <Title :title-name="title.Welcome.titleName" :title-link="title.Welcome.titleLink" />
    <div v-if="Object.keys(airline).length && Object.keys(pax).length" class="container" style="margin-top: 14pt">
      <p class="content-wellcome" v-html="welcomeText"></p>
    </div>
  </div>
</template>

<script>
import Title from '@/components/Title'
import { replaceStr } from '@/utils/helper'

export default {
  name: 'Welcome',
  components: {
    Title
  },
  props: {
    secret: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      curPaxInfo: null
    }
  },
  computed: {
    welcomeText() {
      let self = this
      let welcomeTextByFlag = self.getWelcomeMessageByFlag(self.pax.irreg_reason)
      self.curPaxInfo = self.getCurrentPassengerInfo() || self.pax
      let welcomeText = self.replaceStr(
        welcomeTextByFlag[self.pax.class],
        [
          '<title>',
          '<gender>',
          '<pax_first_name>',
          '<pax_last_name>',
          '<airline_name>',
          '<carrier_code>',
          '<flight_number>',
          '<route>',
          '<std>',
          '<etd>',
          '<dep>',
          '<arr>',
          '<div>',
          '<div_airport_name>'
        ],
        [
          self.curPaxInfo.title,
          self.curPaxInfo.gender,
          self.curPaxInfo.first_name,
          self.curPaxInfo.last_name,
          self.airline.name,
          self.pax.carrier,
          self.pax.flight_no,
          self.pax.dep + '-' + self.pax.arr,
          self.pax.std,
          self.pax.etd,
          self.pax.dep,
          self.pax.arr,
          self.pax.div,
          self.pax.div_airport_name
        ]
      )
      welcomeText = this.Autolinker.link(welcomeText, {
        stripPrefix: false
      })
      return welcomeText
    }
  },
  watch: {
    airline: function () {
      if (!_.isEmpty(this.pax)) {
        this.checkEnabledWelcomeMessage()
      }
    },
    pax: function () {
      if (!_.isEmpty(this.airline)) {
        this.checkEnabledWelcomeMessage()
      }
    }
  },
  created() {
    if (!_.isEmpty(this.airline) && !_.isEmpty(this.pax)) {
      this.checkEnabledWelcomeMessage()
    }
  },
  methods: {
    replaceStr,
    checkEnabledWelcomeMessage() {
      if (
        this.airline.params.enabled_welcome_text_mobile != 1 ||
        this.airline.params.enable_class[this.pax.class] != 1 ||
        _.isUndefined(this.getWelcomeMessageByFlag(this.pax.irreg_reason))
      ) {
        // Not enabled welcome message yet
        // Or cabin class of passenger is disabled in admin backend
        // Or there is no welcome message for passenger's flag
        this.$router.push({ path: '/home', query: { secret: this.secret } })
        return
      }
    },
    getWelcomeMessageByFlag(flag) {
      return _.find(this.pax.welcome, function (e) {
        return e.FLAG == flag
      })
    },
    getCurrentPassengerInfo() {
      let self = this
      if (!_.isEmpty(self.PaxsGroup) && !_.isEmpty(self.pax)) {
        return _.find(self.PaxsGroup, function (pax) {
          return pax.passenger_id == self.pax.curPaxID
        })
      }
    }
  }
}
</script>

<style lang="scss">
.content-wellcome {
  white-space: pre-line;
  a {
    font-size: inherit;
  }
}
</style>
